import notificationError from '@/utils/functions/notificationError';
import { notification } from 'antd';
import { useMutation } from 'react-query';
import { getReturnedPurchaseReport } from './Purchase.service';

export function useReturnedPurchaseReport() {
  return useMutation(getReturnedPurchaseReport, {
    onSuccess() {
      notification.success({
        message: 'O relatório de Compras Devolvidas foi gerado com sucesso!',
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}
